import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'card-wrapper',
    templateUrl: './card-wrapper.component.html',
})
export class CardWrapperComponent extends FieldWrapper {
}
